<div class="audio-recorder-container">

  <div class="audio-visualization">
    <div *ngIf="isRecording" class="audio-wave">
      <div class="audio-bar" *ngFor="let i of [1, 2, 3, 4, 5]"></div>
    </div>
    <audio #audioPreview *ngIf="audioURL && !isRecording" [src]="audioURL" controls></audio>
    <div *ngIf="!isRecording && !audioURL" class="audio-placeholder">
      Ready to record audio
    </div>
  </div>


  <div class="controls-container">
    <div class="button-group">
      <button class="record-button" [disabled]="isRecording" (click)="toggleRecording()">
        Record
      </button>
      <button class="stop-button" [disabled]="!isRecording" (click)="stopRecording()">
        Stop
      </button>
      <button class="switch-mic-button" [disabled]="audioDevices.length <= 1" (click)="switchMicrophone()">
        Switch Mic
      </button>
    </div>

    <div class="timer-display" [ngClass]="{'timer-warning': remainingTime <= 5}">
      {{ formatRemainingTime() }}
    </div>

    <div *ngIf="audioDevices.length > 0" class="mic-display">
      Current mic: {{ getCurrentMicrophoneName() }}
    </div>
  </div>
</div>